import { render, staticRenderFns } from "./SelectedChips.vue?vue&type=template&id=aaa31fc0&scoped=true&"
import script from "./SelectedChips.vue?vue&type=script&lang=js&"
export * from "./SelectedChips.vue?vue&type=script&lang=js&"
import style0 from "./SelectedChips.vue?vue&type=style&index=0&id=aaa31fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa31fc0",
  null
  
)

export default component.exports